import React from "react";

export default function Card({title, right, children}: React.PropsWithChildren<{title?: string; right?: React.ReactNode}>){
    return (
        <div className="idk-card">
            {title && (
                <div className="idk-card--header">
                    <h3>{title}</h3>
                    <div>{right}</div>
                </div>
            )}
            {children}
        </div>
    );
}